import { render } from "./SwipeArea.vue?vue&type=template&id=c9540e3e"
import script from "./SwipeArea.vue?vue&type=script&lang=js"
export * from "./SwipeArea.vue?vue&type=script&lang=js"

import "./SwipeArea.vue?vue&type=style&index=0&id=c9540e3e&lang=css"

import exportComponent from "C:\\PRO\\TimeSheet\\vue-cal-dev-ts-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__